import React from 'react'
import { Link } from "react-router-dom";

export default function Error() {
  return (
    <>
    <section className="error-page">
        <div className="errorbox">
            <div className="error-textbox">
                <h1>This Page</h1>
                <img src="/image/404.webp" className="img-responsive" alt="404"/>
                <h2>doesn’t exist</h2>
            </div>

            <div className="error-buttonbox">
                <Link to={"/"} className="default-btn red-default">Back To Homepage</Link>
                <Link to={"/contact"} className="default-btn">Contact Us</Link>
            </div>
        </div>
    </section>
    </>
  )
}
